import { ReactElement, useMemo } from 'react';
import { Box, Stack } from '@ff-it/ui';
import { Submit } from '@ff-it/form';
import { Campaigns } from './Campaigns';
import { useLinkerState } from './useLinkerState';
import { FilterForm, useFilterState } from '../filter';
import { LinkerSummary } from '../LinkerSummary';
import { LinkerFields } from '../LinkerFields';
import { LinkerProps } from './types';
import { FilterFields } from './FilterFields';

export function NetLinker({ invoice, disabled, direction, renderCandidatesTop, ...props }: LinkerProps): ReactElement {
  const block = useMemo(() => {
    if (invoice.direction !== 'expense' || !invoice.rows) {
      return [];
    }
    const codes = new Set<string>();
    invoice.rows.forEach((row) => {
      if (row.block_code) {
        codes.add(row.block_code);
      }
    });
    return Object.values(props.entities.block)
      .filter(({ code }) => codes.has(code))
      .map(({ id }) => id.toString());
  }, [invoice, props.entities.block]);

  const initialValues = {
    block,
    client: (invoice.clients || []).map(({ id }) => id.toString()),
  };

  const [filterState, setFilterState] = useFilterState(initialValues);

  const { summary, linked, candidates } = useLinkerState(invoice, props, filterState);
  return (
    <Stack direction="horizontal">
      <Box pr="2" width="full">
        <Box display="flex" alignItems="flex-start">
          <Box flexGrow={1}>
            <LinkerFields />
          </Box>
          {!disabled && <Submit className="ml-3" />}
        </Box>
        <LinkerSummary state={summary} direction={direction} mb="2" />
        <Campaigns side="linked" rows={linked} entities={props.entities} />
      </Box>
      {disabled ? (
        <Box width="full" />
      ) : (
        <Box pl="2" width="full">
          {renderCandidatesTop?.()}
          <FilterForm filter={filterState} setFilter={setFilterState}>
            <FilterFields entities={props.entities} clients={initialValues.client} />
          </FilterForm>
          <Campaigns side="candidates" rows={candidates} entities={props.entities} />
        </Box>
      )}
    </Stack>
  );
}
